module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "home"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [(_vm.songCount > 0) ? _c('div', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("“" + _vm._s(_vm.$route.query.s) + "”的搜索结果")]), _vm._v(" "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v("找到 " + _vm._s(_vm.songCount) + " 首歌曲")])]) : (!_vm.loading) ? _c('div', {
    staticClass: "empty-tips"
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-1",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("library_music")]), _vm._v(" "), (!!_vm.$route.query.s) ? _c('p', [_vm._v("无“" + _vm._s(_vm.$route.query.s) + "”相关歌曲")]) : _c('p', [_vm._v("您尚未搜索任何歌曲")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('v-progress-circular', {
    staticClass: "teal--text text--lighten-2",
    attrs: {
      "indeterminate": "",
      "size": 60
    }
  }), _vm._v(" "), _c('p', [_vm._v("加载中...")])], 1)]), _vm._v(" "), _c('music-list', {
    attrs: {
      "items": _vm.items
    }
  }), _vm._v(" "), (_vm.pageTotal > 1) ? _c('v-card-text', {
    staticClass: "pagination-container"
  }, [_c('v-pagination', {
    attrs: {
      "circle": "",
      "length": _vm.pageTotal
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21e5ac6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 145
// module chunks = 1